import { min_value, integer } from '@vee-validate/rules';
import { defineRule } from 'vee-validate';
import moment from 'moment';
import {dateGreaterOrEqualTest } from '@/components/mixins/ValidatedInput.js';



defineRule('valid-date', (value, { isValidDate, rowData, propertyName }) => {
    if (isValidDate(rowData[propertyName])) return true;
    return `'${rowData.originalData[propertyName]}' is not a supported date.`;
});

defineRule('dateGreaterOrEqualImport', (value, { rowData, propertyName, propertyLabel }) => {
    if (dateGreaterOrEqualTest(value, rowData[propertyName])) return true;
    return `${propertyLabel ? propertyLabel : 'Date'} should be the same as or after ${propertyLabel}`;
});

export default {
    methods: {        
        matchesExistingObject(value, isRequired) {
            if(isRequired === true && this.isEmpty(value)){
                return false;
            }
            //test for -1 instead of > 0 to work with store options that have a string instead of
            //id for the value (ex courseRequestTypes)
            return (
                this.isEmpty(value) || value !== -1                
            );
        },

        isNonNegativeInteger(value, isRequired) {
            if(isRequired === true && this.isEmpty(value)){
                return false;
            }

            return this.isEmpty(value)
            || (min_value(value, { min: 0 }) === true
            && integer(value) === true);

        },
        isEmpty(value){
            return value === '' || value === undefined || value === null;
        },

        isValidDate(value) {
            if (!value) {
                return true;
            }
            return moment(
                value,
                this.$validDates,
                true
            ).isValid();
        }
    }
};
